const csvCell = (value) => {
    let text = value == null ? "" : typeof value === "number"
        ? (Number.isFinite(value) ? String(value).replace(".", ",") : "") : String(value);
    // Spreadsheet applications interpret these prefixes as formulas, even in quoted cells.
    if (typeof value === "string" && (/^\s*[=+\-@]/.test(text) || /^[\t\r\n]/.test(text))) text = `'${text}`;
    return `"${text.replace(/"/g, '""')}"`;
};

export const serializeCsv = (rows) => `\uFEFF${rows.map((row) => row.map(csvCell).join(";")).join("\r\n")}\r\n`;

export const downloadCsv = (filename, rows) => {
    const safeFilename = Array.from(filename, (character) => (
        character.charCodeAt(0) < 32 || '<>:"/\\|?*'.includes(character) ? "_" : character
    )).join("");
    const blob = new Blob([serializeCsv(rows)], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${safeFilename.replace(/\.csv$/i, "") || "export"}.csv`;
    document.body.appendChild(link);
    try { link.click(); } finally {
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
};
